import api from "./api";
import { generateErrorMessage } from "../utils/message";


/*Mastergroupings*/
export const registerMastergrouping = async (mastergroupingData) => {
  try {
    const response = await api.post("/mastergroupings/", mastergroupingData);
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("register", "mastergrouping");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

export const fetchMastergroupingsFromAPI = async (page = 1, perPage = 10, search = "") => {
  try {
    const response = await api.get("/mastergroupings", {
      params: { page, per_page: perPage, search },
    });

    return response.data.data;
  } catch (error) {
    const fallback = generateErrorMessage("get data", "mastergrouping");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

export const deleteMastergroupingsFromAPI = async (mastergroupingId) => {
  try {
    const response = await api.delete(`/auth/mastergroupings/${mastergroupingId}`, {
      params: { mastergrouping_id: mastergroupingId },
    });
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("delete data", "mastergrouping");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};


export const fetchMastergroupingsById = async (mastergroupingId) => {
  try {
    const response = await api.get(`/auth/mastergroupings/${mastergroupingId}`);
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("get data mastergrouping", "mastergrouping");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};

export const updateMastergrouping = async (id, mastergroupingData) => {
  try {
    const response = await api.put(`/auth/mastergroupings/${id}`, mastergroupingData);
    return response.data;
  } catch (error) {
    const fallback = generateErrorMessage("update", "mastergrouping");
    const msg = error.response?.data?.message || fallback;
    throw new Error(msg);
  }
};


